module.exports = __webpack_public_path__ + "fonts/poppins_semi_bold.2ad71a5.ttf";